import * as Yup from "yup";
import { FormGroup } from "../../../../components/form";

export const applicationTypeLegacyForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "typeOfApplication",
      fieldType: "dropdown",
      label: "Type of Application",
      props: {
        placeholder: "Select an application type",
        options: [
          {
            label: "Disability only",
            value: 1,
          },
          {
            label: "Disability with Complex Medical Needs",
            value: 2,
          },
          {
            label: "Complex Medical Needs only",
            value: 3,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },

    {
      type: "formGroup",
      key: "applicationCategory",
      label: "Application Category",
      hideExpression: (context, values) => values.typeOfApplication > 2,
      test: [
        "chooseOne",
        "A response is required",
        (value: any) => {
          return value.significantRisk || value.restrictedCapacityForMovement || value.notProvided;
        },
      ],
      props: {
        isRequired: true,
      },
      fields: [
        {
          type: "field",
          fieldType: "checkbox",
          key: "significantRisk",
          label: "Significant risk",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "restrictedCapacityForMovement",
          label: "Restricted capacity for movement",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "notProvided",
          label: "Not Provided",
        },
        {
          type: "field",
          key: "advisory",
          fieldType: "advisory",
          props: {
            type: "fieldadv",
          },
          label: "Record the category under which the kindergarten is applying",
        },
      ],
    },
  ],
};
